export const CyProfile = {
  PermissionList: "PermissionList",
  PermissionGranted: "PermissionGranted",
  PermissionDeclined: "PermissionDeclined",
  LogoutButton: "LogoutButton",
  ProfileForm: "ProfileForm",
  FirstNameInput: "FirstNameInput",
  LastNameInput: "LastNameInput",
  SaveProfileButton: "SaveProfileButton",
  SaveStatusAlert: "SaveStatusAlert",
  ReadOnlyFirstName: "ReadOnlyFirstName",
  ReadOnlyLastName: "ReadOnlyLastName",
  NoProfileDataAlert: "NoProfileDataAlert",
  ProfileNotAvailableAlert: "ProfileNotAvailableAlert",
  BackToOwnProfileButton: "BackToOwnProfileButton",
} as const;
